import { Box } from '@mui/system';
import TenantLogoImage from './TenantLogoImage';

const styles = {
    minHeight: '150px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
};

const Logo = ({ width, code }) => (
    <Box width={width}
        marginTop={3}
        sx={styles}
    >
        <TenantLogoImage
            width="100%"
            code={code}
            alt="logo"
            fallbackSrc="/assets/Full-FNI.png"
        />
    </Box>
);

export default Logo;
